<script>
</script>

<div class="main-section">
    RealDO
</div>

<style>
    .main-section {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        font-size: 21px;
        font-weight: 800;
        font-family: 'Roboto Mono', monospace;
        background-color: var(--primary-color);
    }
</style>
